
/* injects from baggage-loader */

// $uibModal

'use strict';

import { filter, sampleSize } from 'lodash';

export default function (app) {
	app
		.factory('Trophies', Trophies);

	function Trophies($log, Session) {
		'ngInject';

		let self = {};


		self.getThrophies = function () {
			let { trophies } = Session.get();
			return trophies;
		};
		self.getCollectThrophies = function () {
			let { trophies } = Session.get();
			return filter(trophies, { collected: true });
		};

		self.collectThrophies = function(total){
			try{
				let { trophies } = Session.get();
				let collecteds = [];
				let notCollected = filter(trophies, { collected: false });

				collecteds = collecteds.concat( sampleSize(notCollected, total) );

				collecteds.forEach( throphy => {            
					trophies.forEach(t => throphy.name === t.name ? t.collected = true : false);
				});
				// comit
				saveTrophies(trophies);
				return collecteds;
			} catch(e){
				$log.warn(e);
			}
		};
		function saveTrophies(trophies) {
			let updates = Session.get();
			updates.trophies = trophies;
			// update storage
			Session.save(updates, true);
		}
		return self;
	}
}



// WEBPACK FOOTER //
// ./src/app/core/services/trophies.factory.js